import $ from "jquery"
import Vue from "vue"
import * as ers from "../../../errorsmessages/errors"
import * as suc from "../../../successmessages/success"
import * as rt from "../../../routes/routes"
import * as ses from "../../../configurations/session/sessioncomplete"
import baseurl from "../../../configurations/baseurl/baseurl"
import router from "../../../router/index"
import moment from 'moment';

export const actions = {

  checkIn({ commit},empID)  {
    let attendances = {
      employee_id: empID
    }
    $('.creatingAttendance').hide()
    $('.creatingAttendanceLoader').show()
    baseurl
        .post(rt.checksIn, attendances)
       
        .then(res => {
          $('.creatingAttendance').show()
          $('.creatingAttendanceLoader').hide()

           //checking for response codes from backend

           if (res.data.code === 200){
             suc.attendanceCreateSuccess()
             commit("STORE_SYSTEM_ATTENDANCE", res.data.attendances)
           }else if (res.data.code === 402) {
            ers.validateErrors()
          } else if (res.data.code === 403) {
            ers.attendanceExists()
          } else if (res.data.code === 404) {
            ers. errorUpdatingAttendance()
          } else if (res.data.code === 405) {
            ers.noPermissionToCreate()
            router.push('/dashboard')

          } else if (res.data.code === 506) {
            ses.sessionComplete()
          }
        })
  },
  loadAttendances ({commit}) {
    baseurl
        .get(rt.loadAttendances)
        .then(res => {
          $('.attendancesLoader').hide()

          //checking for response codes from backend

          if (res.data.code === 200) {
            //success code
            commit("STORE_SYSTEM_ATTENDANCE", res.data.attendances)
          } else if (res.data.code === 404) {
            //error code on loading attendances records
            ers.errorLoadingAttendance()
          } else if (res.data.code === 405) {
            //no permission code
            ers.noPermissionToRead()
            router.push('/dashboard')
          } else if (res.data.code === 506) {
            //session expired code
            ses.sessionComplete()
          }
        })
    },

    loadAttendance ({commit}) {
      baseurl
          .get(rt.loadAttendance)
          .then(res => {
            $('.attendancesLoader').hide()
  
            //checking for response codes from backend
  
            if (res.data.code === 200) {
              //success code
              commit("STORE_ATTENDANCES", res.data.attendance)
            } else if (res.data.code === 404) {
              //error code on loading attendances records
              ers.errorLoadingAttendance()
            } else if (res.data.code === 405) {
              //no permission code
              ers.noPermissionToRead()
              router.push('/dashboard')
            } else if (res.data.code === 506) {
              //session expired code
              ses.sessionComplete()
            }
          })
      },
    checkOut ( {commit}, attendanceId) {
      let attendances = {
        id: attendanceId
      }
      $('.updatingAttendanceLoader').show()
      $('.updatingAttendance').hide()
      baseurl
        .post(rt.checksOut, attendances)
        .then(res => {
          $('.updatingAttendanceLoader').hide()
          $('.updatingAttendance').show()


          //checking response codes from backend
        
          if (res.data.code === 200) {
            suc.attendanceUpdateSuccess()
            commit("STORE_SYSTEM_ATTENDANCE", res.data.attendances)
          } else if (res.data.code === 402){
            ers.validateErrors()
          } else if (res.data.code === 404) {
            ers.errorUpdatingAttendance()
          } else if (res.data.code === 405) {
            ers.noPermissionToUpdate()
            router.push('/dashboard')
          } else if (res.data.code === 506) {
            ses.sessionComplete()
          }
        })
    },
    getHumanDate : function (date) {

      return moment(date, 'YYYY-MM-DD').format('Y-M-D');

  },

  viewAttendance({commit}, data) {
    commit("STORE_ATTENDANCE_UPDATE", data)
    router.push("/generatepayroll")
  }


}
export default actions



// WEBPACK FOOTER //
// ./src/vuex/modules/attendances/actions.js